var _SUPPORTED_LOCALIZATI;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { LANGUAGE_ENGLISH_NAME, LANGUAGE_SPANISH_NAME } from 'js/constants/text';
export var LANGUAGE_CODE_ENGLISH = 'en';
export var LANGUAGE_CODE_SPANISH = 'es';
export var SUPPORTED_LOCALIZATION_LANGUAGES = [LANGUAGE_CODE_ENGLISH, LANGUAGE_CODE_SPANISH];
export var SUPPORTED_LOCALIZATION_LANGUAGE_NAME_MAP = (_SUPPORTED_LOCALIZATI = {}, _defineProperty(_SUPPORTED_LOCALIZATI, LANGUAGE_CODE_SPANISH, LANGUAGE_SPANISH_NAME), _defineProperty(_SUPPORTED_LOCALIZATI, LANGUAGE_CODE_ENGLISH, LANGUAGE_ENGLISH_NAME), _SUPPORTED_LOCALIZATI);